import React from 'react'
import './index.scss'

const Appointment = ({ noImage, image }) => (
  <div className="appointment">
    <div className="appointment__container">
      <span>Jetzt Ihren persönlichen</span>
      <h2> Beratungstermin vereinbaren</h2>
      <a href="tel: +4369917407454" className="button">
        +43 (0) 699 174 074 54
      </a>
      {noImage ? '' : <img src={image} />}
    </div>
  </div>
)

export default Appointment
